<template>
  <section id="main-wrap" class="pure-g">
    <div id="main-col" class="pure-u-3-5">

      <h3>{{this.$route.params.username}}'s grapes</h3>

      <div id="home-grapes" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="500">
        <Grape v-for="grape in grapes" :grapeInstance="grape" :key="grape.id" />
      </div>

    </div>
  </section>

</template>

<script>
  import Grape from './Grape.vue'
  import db from './firebaseInit'
  import firebase from 'firebase'

  export default {
    name: 'grapevine',
    data () {
      return {
        grapeIDs: [],
        grapes: [],
        username: '',
        loading: true,
        enableLoadMore: true,
        isLoading: false,
        search: '',
        lastVisible: null,
        grapesDatabase: this.$globals.grapesDatabase,
        isPress: this.$globals.isPress
      }
    },
    created () {
      this.getUserID()
      this.fetchData()
    },
    watch: {
      '$route': 'fetchData'
    },
    methods: {
      fetchData () {
        this.getGrapes()
      },
      getUserID: function () {
        var vm = this
        vm.username = this.$route.params.username
        firebase.database().ref('usernames/' + vm.username).once('value', function (snapshot) {
          var exists = (snapshot.val() !== null)
          if (exists) {
            vm.$eventHub.$emit('grape-user-trigger', snapshot.val(), vm.username)
          }
        })
      },
      getGrapes: function () {
        var vm = this
        vm.grapes = []
        var grapesRef = db.collection(vm.grapesDatabase).where('grapeUsername', '==', this.$route.params.username).orderBy('updatedTimestamp', 'desc').limit(20)
        grapesRef.get().then((querySnapshot) => {
          this.isLoading = true
          console.log('created query, # of docs: ' + querySnapshot.docs.length)
          this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
          querySnapshot.forEach((doc) => {
            var grapeData = doc.data()
            grapeData.docID = doc.id
            this.grapes.push(grapeData)
          })
          setTimeout(function () {
            vm.isLoading = false
          }, 2000)
        })
      },
      loadMore: function () {
        var vm = this
        if (this.lastVisible && !this.isLoading && this.enableLoadMore) {
          this.isLoading = true
          var grapesRef = db.collection(vm.grapesDatabase).where('grapeUsername', '==', this.$route.params.username).orderBy('updatedTimestamp', 'desc').startAfter(this.lastVisible).limit(20)
          grapesRef.get().then((querySnapshot) => {
            this.lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1]
            querySnapshot.forEach((doc) => {
              var grapeData = doc.data()
              grapeData.docID = doc.id
              this.grapes.push(grapeData)
            })
            setTimeout(function () {
              vm.isLoading = false
            }, 2000)
          })
        }
      }
    },
    components: {
      Grape
    }
  };
</script>

<style scoped>
  #main-wrap {
    background: #f9f9f9;
    min-height: 100vh;
  }
  #add-grape-button {
    width: 100%;
    margin: 0 auto 20px;
    background: #36a731;
    color: #fff;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    padding: 15px 20px;
  }
  #search-grapes {
    width: 60%;
    margin: 0 auto 20px;
    line-height: 30px;
    padding-left: 5px;
    padding-right: 5px;
    box-sizing: border-box;
  }
  #home-grapes {
    margin-top: 40px;
  }
  .aux-col {
    box-sizing: border-box;
    padding: 30px 50px;
    text-align: left;
  }
  .aux-col > h5 {
    text-transform: uppercase;
    border-bottom: 1px solid #36a731;
    margin: 0 0 20px;
    padding-bottom: 8px;
    display: inline-block;
  }
</style>


// WEBPACK FOOTER //
// src/components/User.vue